import React from "react"
import { SitesContext } from "../SitesProvider"

export function useFetchSites(): () => void {
  const context = React.useContext(SitesContext)
  if (context === undefined) {
    throw new Error("loadSites must be used within a SitesProvider")
  }
  return context.getSites
}

export function useFetchSite(): (id: string) => void {
  const context = React.useContext(SitesContext)
  if (context === undefined) {
    throw new Error("getSite must be used within a SitesProvider")
  }
  return context.getSite
}

export function useSiteLoading(): boolean {
  const context = React.useContext(SitesContext)
  if (context === undefined) {
    throw new Error("getSite must be used within a SitesProvider")
  }
  return context.loading
}
